import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { UserImpl } from "../model/impl/UserImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class UserImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: UserImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(1),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.userCode != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(2),
        false,
        encodable.userCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.userId != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(3),
        false,
        encodable.userId,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.userName != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(4),
        false,
        encodable.userName,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.userType != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(5),
        false,
        encodable.userType,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.branchCode != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(6),
        false,
        encodable.branchCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.authProvider != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(7),
        false,
        encodable.authProvider,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.emailAddress != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(8),
        false,
        encodable.emailAddress,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.smsNumber != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(9),
        false,
        encodable.smsNumber,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.sendEmailMyOrdEnteredFg != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(10),
        false,
        encodable.sendEmailMyOrdEnteredFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.sendSMSMyOrdEnteredFg != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(11),
        false,
        encodable.sendSMSMyOrdEnteredFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.sendEmailMyOrdFillFg != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(12),
        false,
        encodable.sendEmailMyOrdFillFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.sendSMSMyOrdFillFg != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(13),
        false,
        encodable.sendSMSMyOrdFillFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.sendEmailMyOrdExpiryFg != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(14),
        false,
        encodable.sendEmailMyOrdExpiryFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.sendSMSMyOrdExpiryFg != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(15),
        false,
        encodable.sendSMSMyOrdExpiryFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.sendEmailAnyOrderIFillFg != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(16),
        false,
        encodable.sendEmailAnyOrderIFillFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.sendSMSAnyOrderIFillFg != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(17),
        false,
        encodable.sendSMSAnyOrderIFillFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCodes != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        true,
        UserImplEncoder.fidTypeMap.get(18),
        false,
        encodable.clientCodes,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.desk != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(19),
        false,
        encodable.desk,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.comment != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(20),
        false,
        encodable.comment,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.isDefault != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(21),
        false,
        encodable.isDefault,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.sendEmailMyOrdModifyFg != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(22),
        false,
        encodable.sendEmailMyOrdModifyFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.sendSMSMyOrdModifyFg != null) {
      this.baseEncoder.writeStartFid(23, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(23),
        false,
        encodable.sendSMSMyOrdModifyFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(23, streamout);
    }
    /*Object encoding*/
    if (encodable.sendEmailMyOrdCancelFg != null) {
      this.baseEncoder.writeStartFid(24, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(24),
        false,
        encodable.sendEmailMyOrdCancelFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(24, streamout);
    }
    /*Object encoding*/
    if (encodable.sendSMSMyOrdCancelFg != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(25),
        false,
        encodable.sendSMSMyOrdCancelFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.roles != null) {
      this.baseEncoder.writeStartFid(26, streamout);
      this.baseEncoder.writeObject(
        true,
        UserImplEncoder.fidTypeMap.get(26),
        false,
        encodable.roles,
        streamout,
      );
      this.baseEncoder.writeEndFid(26, streamout);
    }
    /*Object encoding*/
    if (encodable.cmeEbsId != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(27),
        false,
        encodable.cmeEbsId,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.cmeEbsLocation != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(28),
        false,
        encodable.cmeEbsLocation,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.uiEnabledFg != null) {
      this.baseEncoder.writeStartFid(29, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(29),
        false,
        encodable.uiEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(29, streamout);
    }
    /*Object encoding*/
    if (encodable.defaultPublicProfileId != null) {
      this.baseEncoder.writeStartFid(30, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(30),
        false,
        encodable.defaultPublicProfileId,
        streamout,
      );
      this.baseEncoder.writeEndFid(30, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        UserImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,UserImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.Long"],
    [4, "java.lang.String"],
    [5, "com.bcdfx.model.UserType"],
    [6, "java.lang.String"],
    [7, "java.lang.String"],
    [8, "java.lang.String"],
    [9, "java.lang.String"],
    [10, "java.lang.Boolean"],
    [11, "java.lang.Boolean"],
    [12, "java.lang.Boolean"],
    [13, "java.lang.Boolean"],
    [14, "java.lang.Boolean"],
    [15, "java.lang.Boolean"],
    [16, "java.lang.Boolean"],
    [17, "java.lang.Boolean"],
    [18, "java.lang.String"],
    [19, "java.lang.String"],
    [20, "java.lang.String"],
    [21, "java.lang.Boolean"],
    [22, "java.lang.Boolean"],
    [23, "java.lang.Boolean"],
    [24, "java.lang.Boolean"],
    [25, "java.lang.Boolean"],
    [26, "java.lang.String"],
    [27, "java.lang.String"],
    [28, "java.lang.String"],
    [29, "java.lang.Boolean"],
    [30, "java.lang.Long"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: UserImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.userCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.userId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.userName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.UserType = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.userType = <CubiqTS.UserType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.branchCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.authProvider = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.emailAddress = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.smsNumber = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.sendEmailMyOrdEnteredFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.sendSMSMyOrdEnteredFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.sendEmailMyOrdFillFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.sendSMSMyOrdFillFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.sendEmailMyOrdExpiryFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.sendSMSMyOrdExpiryFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.sendEmailAnyOrderIFillFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.sendSMSAnyOrderIFillFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            UserImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.clientCodes = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.desk = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.comment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.isDefault = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(22),
            streamin,
          );
          encodable.sendEmailMyOrdModifyFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 23: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(23),
            streamin,
          );
          encodable.sendSMSMyOrdModifyFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 24: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(24),
            streamin,
          );
          encodable.sendEmailMyOrdCancelFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(25),
            streamin,
          );
          encodable.sendSMSMyOrdCancelFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 26: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            UserImplEncoder.fidTypeMap.get(26),
            streamin,
          );
          encodable.roles = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(27),
            streamin,
          );
          encodable.cmeEbsId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(28),
            streamin,
          );
          encodable.cmeEbsLocation = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 29: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(29),
            streamin,
          );
          encodable.uiEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 30: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(30),
            streamin,
          );
          encodable.defaultPublicProfileId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UserImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,UserImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return UserImplEncoder.fidTypeMap.has(fid);
  }
}
